export default [
  {
    name: "Amplitude Analytics SDK",
    package: "@amplitude/analytics-react-native",
    purpose: "进行应用数据统计分析及用户行为分析",
    fields: "设备信息（Android ID / IDFA / OAID / 设备号）、网络信息、使用数据、用户交互信息",
    company: "Amplitude, Inc.",
    privacyUrl: "https://amplitude.com/privacy",
  },
  {
    name: "Singular SDK",
    package: "singular-react-native",
    purpose: "移动归因与营销分析，用于衡量广告投放表现",
    fields:
      "设备标识符（IDFA、Google Advertising ID、Android ID）、IP 地址、User Agent、网络信息、安装来源、广告活动数据、应用使用事件、应用内购买记录",
    company: "Singular Labs, Inc.",
    privacyUrl: "https://www.singular.net/privacy-policy/",
  },
  {
    name: "React Native Device Info",
    package: "react-native-device-info",
    purpose: "收集设备信息以支持应用功能与分析",
    fields: "设备制造商、型号、操作系统版本、设备唯一标识符、内存信息",
    company: "React Native Community",
    privacyUrl: "https://github.com/react-native-device-info/react-native-device-info",
  },
  {
    name: "Stripe React Native SDK",
    package: "@stripe/stripe-react-native",
    purpose: "处理预订及服务相关的支付",
    fields: "支付信息、交易详情、设备信息",
    company: "Stripe, Inc.",
    privacyUrl: "https://stripe.com/privacy",
  },

  {
    name: "美洽 SDK",
    purpose: "实现客户在线咨询即时解决客户的问题",
    fields:
      "应用信息（应用名字、应用版本号）、设备品牌、设备型号、设备语言、系统版本、分辨率、网络状态、时区信息",
    company: "成都美洽网络科技有限公司",
    privacyUrl: "https://www.meiqia.com/privacy-clause",
  },
  {
    name: "React Native Image Picker",
    package: "react-native-image-picker",
    purpose: "允许用户上传头像或房源照片",
    fields: "相机照片、图库图片、图片元数据",
    company: "React Native Community",
    privacyUrl: "https://github.com/react-native-image-picker/react-native-image-picker",
  },
  {
    name: "React Native IDFA AAID",
    package: "@sparkfabrik/react-native-idfa-aaid",
    purpose: "获取广告标识符以用于归因及分析",
    fields: "广告 ID（iOS 为 IDFA，Android 为 AAID）、设备信息",
    company: "Sparkfabrik",
    privacyUrl: "https://github.com/sparkfabrik/sparkfabrik-react-native-idfa-aaid",
  },
  {
    name: "React Native App Tracking Transparency",
    package: "react-native-tracking-transparency",
    purpose: "管理用户跟踪偏好与授权（仅适用于 iOS）",
    fields: "跟踪授权状态、设备广告标识符",
    company: "React Native Community",
    privacyUrl: "https://github.com/mrousavy/react-native-tracking-transparency",
  },
  {
    name: "React Native In App Review",
    package: "react-native-in-app-review",
    purpose: "支持应用内评价提示功能",
    fields: "评价内容、应用使用上下文",
    company: "React Native Community",
    privacyUrl: "https://github.com/MinaSamir11/react-native-in-app-review",
  },
  {
    name: "React Native Video",
    package: "react-native-video",
    purpose: "播放房源视频及教育类内容",
    fields: "视频观看数据、设备能力、网络信息",
    company: "React Native Community",
    privacyUrl: "https://github.com/react-native-video/react-native-video",
  },
  {
    name: "React Native WebView",
    package: "react-native-webview",
    purpose: "在应用内展示网页内容，如隐私政策、用户服务协议、第三方信息共享说明等",
    fields: "浏览数据、Cookies、网页表单输入信息",
    company: "React Native Community",
    privacyUrl: "https://github.com/react-native-webview/react-native-webview",
  },
  {
    name: "React Native Async Storage",
    package: "@react-native-async-storage/async-storage",
    purpose: "在设备上进行本地数据存储",
    fields: "应用偏好设置、用户设定、缓存数据",
    company: "React Native Community",
    privacyUrl: "https://github.com/react-native-async-storage/async-storage",
  },
  {
    name: "React Native Clipboard",
    package: "@react-native-clipboard/clipboard",
    purpose: "访问剪贴板内容，用于分享、验证码自动填充及推荐功能",
    fields: "用户主动触发分享或验证码自动填充时的剪贴板内容",
    company: "React Native Community",
    privacyUrl: "https://github.com/react-native-clipboard/clipboard",
  },
];
